module.exports = __webpack_public_path__ + "img/mobile scanner stand19.9e02d18c.jpg";